import { defineStore } from 'pinia';
import { formatDistance, parseISO } from 'date-fns';
import translator from '@/locale/translator';

export const usePoolmirrorStore = defineStore('poolmirror', () => {
  const statusString = (status: number) => {
    switch (status) {
      case 0:
        return translator.get('publication.status.waiting');
      case 1:
        return translator.get('publication.status.success');
      case -1:
        return translator.get('publication.status.critical');
      case -2:
        return translator.get('publication.status.logical');
      default:
        return translator.get('publication.status.unknown');
    }
  };

  const statusColorClass = (status: number) => {
    switch (status) {
      case 0:
        return 'status-blue';
      case 1:
        return 'status-green';
      case -1:
        return 'status-red';
      case -2:
        return 'status-yellow';
      default:
        return 'status-blue';
    }
  };

  const remainingDays = (enddate: string) => {
    if (!enddate) {
      return 'never';
    }
    return formatDistance(parseISO(enddate), new Date(), {
      addSuffix: true,
    });
  };

  const remainingDaysPercentage = (campaign) => {
    const startdate = parseISO(campaign.startdate);
    const enddate = parseISO(campaign.enddate);
    const now = new Date();

    const totalDays = Math.round((enddate.getTime() - startdate.getTime()) / (1000 * 3600 * 24));
    const remainingDays = Math.round((enddate.getTime() - now.getTime()) / (1000 * 3600 * 24));

    return Math.round((remainingDays / totalDays) * 100);
  };

  return {
    statusString,
    statusColorClass,
    remainingDays,
    remainingDaysPercentage,
  };
});
